import React from 'react';

const LegalTeam = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.5 16C16.294 16 14.5 14.206 14.5 12C14.5 9.794 16.294 8 18.5 8C20.706 8 22.5 9.794 22.5 12C22.5 14.206 20.706 16 18.5 16ZM12 8C9.794 8 8 6.206 8 4C8 1.794 9.794 0 12 0C14.206 0 16 1.794 16 4C16 6.206 14.206 8 12 8ZM5.5 16C3.294 16 1.5 14.206 1.5 12C1.5 9.794 3.294 8 5.5 8C7.706 8 9.5 9.794 9.5 12C9.5 14.206 7.706 16 5.5 16ZM11 24V21C11 19.371 9.7 18.053 8.082 18.008L5.5 21L2.879 18.012C1.279 18.077 0 19.384 0 21V24M24 24V21C24 19.371 22.7 18.053 21.082 18.008L18.5 21L15.879 18.012C14.279 18.077 13 19.384 13 21V24"
        fill="white"
      />
    </svg>
  );
};

export default LegalTeam;
